<template>
    <div class="layout">
        <div class="main" :style="bgHeadImg">
            <Header ref="head"></Header>
            <!-- :style="bgHeadImg" -->
            <div class="mainbox" >
                <!-- isRouterAlive1-{{isRouterAlive1}} -->
                <div class="" v-if='isRouterAlive1'>
                    <router-view ></router-view>
                </div>
            </div>

            <Footer></Footer>
        </div>


    </div>
</template>

<script>
import Header from '../Header'
import Footer from '../Footer'
import topbanner from '../banner/topbanner.vue'

export default {
    name: 'Layout',
    computed:{
        bgHeadImg:function(){
            var str='';
            if(this.bgImg){
                str=`background:url('${this.bgImg}') no-repeat 100%/auto 100%;background-size:100% auto!important;background-position-x: center;background-position-y: 0px;`
            }else{
                str=''
            }
            return str
        }
    },
    provide(){
		return {
			isShow:this.isShow,
		}
	},
    data(){
        return{
            isRouterAlive1:true,
            defStr:'',
            nav:[],
            bannerList:[],
            bgImg:'',
            isHidden:true
        }
    },
    components: {
        Header,
        Footer,
        topbanner
    },
    created(){
       this.getNav()
    },
    mounted(){

    },

    methods:{
        getNav(){
            this.$get('/web/home/queryAllRootList').then(res=>{
                if(res.success){
                    this.bgImg='';
                    if(res.result.headImgPath){ //头部自定义底图
                        this.bgImg=this.$fileAccessHttpUrl(res.result.headImgPath)
                    }
                    this.$refs.head.getNav(res)//调用子组件方法
                }
            })
        },
        changeIndex(url){
            this.$refs.head.getIndex(url)//调用子组件方法
        },
        isShow(){
			this.isRouterAlive1=false;
			this.$nextTick(()=>{
				this.isRouterAlive1=true;
			})
		},
    }
}
</script>
<style lang='scss'>
@import '../../styles/animate.scss';
.layout .main{
    height: 100%;
    width: 100%;
    // background:url('../../assets/img/index/head-1.png') no-repeat;
    background-size:100% auto!important;
    background-position-x: center;
    background-position-y: 0px;
}
.layout .main .mainbox{
    background: transparent;
}
// .layout .main .mainbox{
//     height: 100%;
//     width: 100%;
//     background:url('../../assets/img/index/head-1.png') no-repeat;
//     background-size:100% auto!important;
//     // background-size:cover!important;
//     background-position-x: center;
//     background-position-y: -479px;
// }
</style>
